const ROUNDING_THRESHOLD = 100;

// rounds a given value in tonnes to the nearest tonne value
export function customRound(value: number): number {
  if (value < ROUNDING_THRESHOLD) {
    return Math.round(value);
  }

  const firstThreeDigits = parseInt(value.toString().substring(0, 3)); // gets the first three digits of the number
  const firstTwoDigits = Math.floor(firstThreeDigits / 10);
  const thirdDigit = firstThreeDigits % 10;

  return thirdDigit > 5 ? firstTwoDigits + 1 : firstTwoDigits; // always round .5 down
}

export function formatRoundedTonneValue(originalValue: number, newFirstDigits: number) {
  const numberOfDigits = Math.trunc(originalValue).toString().length; // getting only the integer part of the number
  // rounding up can carry into an extra digit (e.g. 996 -> 100 -> 1000)
  const carry = originalValue >= ROUNDING_THRESHOLD && newFirstDigits >= ROUNDING_THRESHOLD ? 1 : 0;

  return newFirstDigits.toString().padEnd(numberOfDigits + carry, '0');
}

export function roundTonneValue(tonneValue: number) {
  const roundedFirstDigits = customRound(tonneValue);
  const roundedValue = formatRoundedTonneValue(tonneValue, roundedFirstDigits);

  return roundedValue;
}
